import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { useView } from "../context/ViewContext";

const BaseLayout = ({ children }) => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { authData, logout } = useAuth();
  const { updateViewID } = useView();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu);
  };

  const handleNavLinkClick = () => {
    updateViewID('');
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light sticky-top" style={{ backgroundColor: "#97bde0" }}>
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleToggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={toggleMenu ? "navbar-collapse" : "collapse navbar-collapse"} id="navbarNavAltMarkup">
            <div className="navbar-nav me-auto mb-2 mb-lg-0">
              {authData.isAuthenticated ? (
                <>
                  <Link className="nav-item nav-link" to="/home" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-home"></i> <strong>Make Picks</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/managepicks" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-history"></i> <strong>History</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/leaderboard" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-list"></i> <strong>LeaderBoard</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/account" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-user"></i> <strong>Account</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/settings" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-cogs"></i> <strong>Settings</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/support" onClick={handleNavLinkClick}>
                    <i className="fa fa-fw fa-wrench"></i> <strong>Support</strong>
                  </Link>
                </>
              ) : (
                <>
                  <Link className="nav-item nav-link" to="/login">
                    <i className="fa fa-fw fa-sign-in"></i> <strong>Login</strong>
                  </Link>
                  <Link className="nav-item nav-link" to="/sign-up">
                    <i className="fa fa-fw fa-user-o"></i> <strong>Sign-Up</strong>
                  </Link>
                </>
              )}
            </div>
            <div className="navbar-nav ms-auto d-flex align-items-center">
              <a
                className="nav-item nav-link"
                href="https://flamepicks.com"
                title="Switch to New Version"
                style={{ fontSize: '0.75rem', opacity: 0.75 }}
              >
                <i className="fa fa-star"></i> <strong>New Version</strong>
              </a>
              {authData.isAuthenticated && (
                <>
                  <span className="navbar-text me-3">
                    {authData.user?.firstName} {authData.user?.lastName}
                  </span>
                  <button
                    className="nav-link btn btn-clear"
                    onClick={handleLogout}
                    style={{ boxShadow: "none", textAlign: 'left' }}
                  >
                    <i className="fa fa-fw fa-sign-out"></i> <strong>Logout</strong>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
      <div className="container">{children}</div>
    </>
  );
};

export default BaseLayout;